import { Link } from "react-router-dom";

import FeedbackState from "./FeedbackState";
import "./AppRouteFallback.css";

const fallbackContent = {
  loading: {
    title: "Preparing your workspace",
    description: "We are refreshing your account and access permissions.",
    variant: "info",
  },
  setupError: {
    title: "Your access could not be loaded",
    description: "We could not refresh your account permissions. Try again before opening a module.",
    variant: "error",
  },
  moduleError: {
    title: "This page could not be displayed",
    description: "An unexpected display error occurred. Your data and permissions were not changed.",
    variant: "error",
  },
  unavailable: {
    title: "Page unavailable",
    description: "You may not have access to this page, or the address may be incorrect.",
    variant: "info",
  },
};

/** Visible, fail-closed state for route setup, denied routes, and render failures. */
export default function AppRouteFallback({
  mode = "unavailable",
  standalone = false,
  onRetry,
  onSignOut,
}) {
  const content = fallbackContent[mode] || fallbackContent.unavailable;
  const isLoading = mode === "loading";
  const showDashboardLink = mode === "unavailable" || mode === "moduleError";

  return (
    <div
      className={`app-route-fallback${standalone ? " app-route-fallback--standalone" : ""}`}
    >
      <FeedbackState
        variant={content.variant}
        title={content.title}
        description={content.description}
        ariaLive={isLoading ? "polite" : undefined}
        action={(
          <div className="app-route-fallback__actions">
            {isLoading && (
              <span className="app-route-fallback__loader" aria-hidden="true" />
            )}
            {onRetry && !isLoading && (
              <button
                type="button"
                className="rg-ui-feedback-state__button"
                onClick={onRetry}
              >
                Try again
              </button>
            )}
            {onSignOut && !isLoading && (
              <button
                type="button"
                className="rg-ui-feedback-state__button app-route-fallback__secondary-action"
                onClick={onSignOut}
              >
                Sign out
              </button>
            )}
            {showDashboardLink && (
              <Link
                className="rg-ui-feedback-state__button app-route-fallback__dashboard-link"
                to="/"
              >
                Go to Dashboard
              </Link>
            )}
          </div>
        )}
      />
    </div>
  );
}
